import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default function TooltipTable({className, children}) {
  const classNames = classnames('tooltip-table', className)
  return <div className={classNames}>{children}</div>
}

TooltipTable.propTypes = {
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./client/components/Tooltip/TooltipTable.js